export default __webpack_public_path__ + "static/media/third-slide-large.6c2031a6.jpg";